import {
    useState,
    useEffect
} from "react";

import QRCode from "react-qr-code";

import { GenerateQRData } from "../api/qrCode";

import "../App.css";
import "./QRCodeGenerator.css";

export default function QRCodeGenerator() {
    const [code, setCode] = useState("0");
    const [time, setTime] = useState('');

    // const [hwBgw, setHwBgw] = useState(null);

    // const [isRefresh, setIsRefresh] = useState(false);

    const reloadQR = async (isForce = false) => {
                try {
                    const compId = window.localStorage.getItem("companyId");

                    const res = await GenerateQRData(compId);
                    console.log("New QR generated at", new Date().toLocaleTimeString(), "=>", res);
                    setCode(res);
                } catch (ex) {
                    console.error("QR Code Gen ERROR", ex);
                } 
  
    };

    useEffect(() => {
        (
            async () => {
                await reloadQR(true);
            }
        )();

     
        const hw = setInterval(reloadQR, 60000);
        return () => {
            clearInterval(hw);
        };
    }, []);

    useEffect(() => {
    const updateClock = () => {
      const now = new Date();

      let hours = now.getHours();
      const ampm = hours >= 12 ? 'PM' : 'AM';

      hours = hours % 12 || 12;
      let minutes = String(now.getMinutes()).padStart(2, '0');
      let seconds = String(now.getSeconds()).padStart(2, '0');

      setTime(`${hours}:${minutes}:${seconds} ${ampm}`);
    };

    updateClock(); 
    const interval = setInterval(updateClock, 1000);

        return () => clearInterval(interval); 
    }, []);

    return (
        <div className="page-container">
            <strong className="title">QR Code Generator</strong>
            <div className="qrcode-container">
                <div className="clock">{time}</div>
                <QRCode  key={code}  value={ code } size={ 250 } viewBox={`0 0 250 250`} style={{ padding: "20px", borderRadius: "20px", boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.3)" }}/>
            </div>
        </div>
        
    );
}